import { render, staticRenderFns } from "./CertList.vue?vue&type=template&id=fd24fb96&scoped=true"
import script from "./CertList.vue?vue&type=script&lang=js"
export * from "./CertList.vue?vue&type=script&lang=js"
import style0 from "./CertList.vue?vue&type=style&index=0&id=fd24fb96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd24fb96",
  null
  
)

export default component.exports